import { motion } from "framer-motion";
import DigitalImg from "../media/digitalisation.avif";
import DesignImg from "../media/dig_1.avif";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Img1 from "../media/dig_2.avif";
import Img2 from "../media/dig_3.avif";
import Img3 from "../media/dig_4.avif";
import Img4 from "../media/Premium Service.avif";
import { Monitor, Scissors, PenTool } from "lucide-react"; 

export default function Digitalisation() {
    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    return (
        <>
            <Header />
            <main className="bg-white text-gray-800">
                {/* Hero Section */}
                <section className="relative w-full flex flex-col md:flex-row items-center justify-center pt-28 md:pt-44 bg-brand text-white px-6 md:px-16 py-20 overflow-hidden">
                    <motion.div
                        className="md:w-1/2"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1 className="text-4xl md:text-5xl font-bold mb-4">Digitalisation</h1>
                        <p className="text-lg leading-relaxed">
                            At Yking, we leverage cutting-edge technology to provide our clients with
                            the best possible services.
                        </p>
                    </motion.div>

                    <motion.img
                        src={DigitalImg}
                        alt="Digitalisation"
                        className="md:w-1/2 w-full mt-10 md:mt-0 md:ml-10 rounded-lg shadow-lg object-cover"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    />
                </section>

                {/* Inspirational Innovation */}
                <motion.section
                    className="max-w-full flex justify-center gap-10 mx-auto px-6 md:px-10 py-20"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <div className="flex flex-col justify-center" >
                        <h2 className="text-3xl text-center font-serif font-bold text-black mb-6">
                            Inspirational Innovation
                        </h2>
                        <p className="text-gray-700 text-center max-w-4xl leading-relaxed mb-12">
                            From pioneering new design concepts to implementing cutting-edge sourcing and line planning techniques, we’re redefining the approach to fashion. Technology enables us to be more efficient, creative, and reliable. It not only enhances the precision of our designs but also streamlines our processes, allowing us to focus on what matters most: providing our customers with an even higher level of service.
                        </p>
                    </div>
                    {/* <div>
                        <motion.img
                            src={CycleImg}
                            alt="Digital Development Cycle"
                            className="mx-auto w-full max-w-3xl md:w-full"
                            variants={fadeInUp}
                        />
                    </div> */}
                </motion.section>

                {/* Design Research & Expertise */}
                <motion.section
                    className="max-w-6xl mx-auto px-6 md:px-10 py-20 grid md:grid-cols-3 gap-10 text-center"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                    >
                    {/* Icon 1 */}
                    <div>
                        <motion.div
                        whileHover={{ scale: 1.05 }}
                        className="text-brand flex justify-center mb-3"
                        >
                        <Monitor size={80} strokeWidth={1.5} /> 
                        </motion.div>
                        <p className="text-gray-500 font-medium">
                        Product design specialists based across the world.
                        </p>
                    </div>

                    {/* Icon 2 */}
                    <div>
                        <motion.div
                        whileHover={{ scale: 1.05 }}
                        className="text-brand flex justify-center mb-3"
                        >
                        <Scissors size={80} strokeWidth={1.5} />
                        </motion.div>
                        <p className="text-gray-500 font-medium">
                        Fabric and trim research & development design expertise.
                        </p>
                    </div>

                    {/* Icon 3 */}
                    <div>
                        <motion.div
                        whileHover={{ scale: 1.05 }}
                        className="text-brand flex justify-center mb-3"
                        >
                        <PenTool size={80} strokeWidth={1.5} />
                        </motion.div>
                        <p className="text-gray-500 font-medium">
                        Design engagement model.
                        </p>
                    </div>
                </motion.section>

                {/* Image & Quote Section */}
                <motion.section
                    className="flex flex-col md:flex-row items-center justify-center max-w-6xl mx-auto px-6 md:px-10 py-20"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <motion.img
                        src={DesignImg}
                        alt="Design Process"
                        className="w-full md:w-1/2 rounded-lg shadow-lg mb-10 md:mb-0 md:mr-10 object-cover"
                    />
                    <div className="text-center md:text-left">
                        <p className="text-2xl font-serif font-bold mb-4">
                            “At the heart of our company, we embrace pioneering technology.”
                        </p>
                        <a
                            href="/our-story"
                            className="inline-block shadow-2xl mt-3 border border-black text-black px-5 py-2 rounded-md hover:bg-black hover:text-white transition"
                        >
                            What We Do
                        </a>
                    </div>
                </motion.section>

                {/* Bottom Section */}
                <motion.section
                    className="bg-brand text-white py-20 text-center"
                    initial="hidden"
                    whileInView="visible"
                    variants={fadeInUp}
                    viewport={{ once: true }}
                >
                    <h2 className="text-4xl font-serif font-bold mb-10">
                    Principles. Passion. Empowerment.
                    </h2>
                    <div className="flex flex-wrap justify-center gap-40">
                    <img src={Img1} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img2} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img3} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    <img src={Img4} className="w-60 h-60 object-cover rounded-lg shadow-lg" alt="" />
                    </div>
                </motion.section>
            </main>
            <Footer/>
        </>
    );
}
